module.exports = __webpack_public_path__ + "static/media/payment.e77515bb.svg";